import React, { useMemo, useState } from 'react';
import { addMonths, eachDayOfInterval, endOfMonth, format, isBefore, isSameDay, isSameMonth, startOfDay, startOfMonth, subMonths } from 'date-fns';
import { es } from 'date-fns/locale';
import { ChevronLeftIcon, ChevronRightIcon } from './icons/LineIcons';
type BookingCalendarProps = {
  selected: Date | null;
  onSelect: (date: Date) => void;
};
const weekdayLabels = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
export function BookingCalendar({
  selected,
  onSelect
}: BookingCalendarProps) {
  const today = startOfDay(new Date());
  const [cursor, setCursor] = useState<Date>(startOfMonth(today));
  const days = useMemo(() => {
    const start = startOfMonth(cursor);
    const end = endOfMonth(cursor);
    const leading = (start.getDay() + 6) % 7;
    return {
      leading,
      dates: eachDayOfInterval({
        start,
        end
      })
    };
  }, [cursor]);
  const canGoBack = !isSameMonth(cursor, today) && isBefore(today, cursor);
  return <div className="rounded-card border border-white/[0.07] bg-ink p-5" data-id="element-92" data-mp="id0n8uaa4dm5">
      <div className="flex items-center justify-between" data-id="element-93" data-mp="3lhvekdnq8uui">
        <button type="button" onClick={() => canGoBack && setCursor(subMonths(cursor, 1))} disabled={!canGoBack} aria-label="Mes anterior" className="grid h-9 w-9 place-items-center rounded-md border border-steel/70 text-white/80 transition-colors duration-300 hover:border-gold/60 hover:text-gold disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:border-steel/70 disabled:hover:text-white/80" data-id="element-94" data-mp="3gh7mdonri7yp">
          <ChevronLeftIcon className="h-4 w-4" data-id="element-95" data-mp="3uh8ot8jodnga" />
        </button>
        <p className="font-display text-base uppercase tracking-[0.16em] text-white" aria-live="polite" data-id="element-96" data-mp="3ufnpz6qbvicm">
          {format(cursor, 'MMMM yyyy', {
          locale: es
        })}
        </p>
        <button type="button" onClick={() => setCursor(addMonths(cursor, 1))} aria-label="Mes siguiente" className="grid h-9 w-9 place-items-center rounded-md border border-steel/70 text-white/80 transition-colors duration-300 hover:border-gold/60 hover:text-gold" data-id="element-97" data-mp="qtgepyztz8hc">
          <ChevronRightIcon className="h-4 w-4" data-id="element-98" data-mp="2lagkfxo6375m" />
        </button>
      </div>

      <div className="mt-5 grid grid-cols-7 gap-1 text-center" data-id="element-99" data-mp="26iy2hubqz2jm">
        {weekdayLabels.map((label, i) => <span key={`${label}-${i}`} className="py-1 font-sans text-[11px] uppercase tracking-[0.18em] text-ash/70" data-id="element-100" data-mp="2bgptmm4kikmr" data-mpi={i}>
            {label}
          </span>)}

        {Array.from({
        length: days.leading
      }).map((_, i) => <span key={`empty-${i}`} aria-hidden="true" data-id="element-101" data-mp="1nln5yhhi2n7v" data-mpi={i} />)}

        {days.dates.map(date => {
        const disabled = isBefore(date, today);
        const isSelected = selected ? isSameDay(date, selected) : false;
        return <button key={date.toISOString()} type="button" disabled={disabled} onClick={() => onSelect(date)} aria-pressed={isSelected} aria-label={format(date, "d 'de' MMMM yyyy", {
          locale: es
        })} className={`aspect-square rounded-md border font-sans text-sm transition-all duration-200 ${isSelected ? 'border-gold bg-gold font-semibold text-ink' : disabled ? 'cursor-not-allowed border-transparent text-white/20' : 'border-steel/50 text-white/85 hover:border-gold/60 hover:text-gold'}`} data-id="element-102" data-mp="3hwtlje5rvvg4">
              {format(date, 'd')}
            </button>;
      })}
      </div>
    </div>;
}